class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    this.setupFacetFilterClick();
  }
  /*START:Sort By Custom*/
  setupFacetFilterClick() {
    const liItems = this.querySelectorAll('#rocket-SortByCustom li');
    const headingName = this.querySelector('.rocket-SortByCustom__heading-name');
    const sortContainer = this.querySelector('.rocket-select');
    if (!sortContainer) return;
    const select = sortContainer.querySelector('select[name="sort_by"]');
    const faceFilter = document.querySelector('.rocket-facet-filters__field');

    const selectedLi = this.querySelector('#rocket-SortByCustom li.selected');
    if (selectedLi) {
      headingName.textContent = selectedLi.textContent.trim();
    }

    liItems.forEach((li) => {
      li.addEventListener('click', (event) => {
        const selectedValue = li.dataset.value;
        if (faceFilter?.classList.contains('active')) {
          faceFilter.classList.remove('active');
        }

        liItems.forEach((item) => item.classList.remove('selected'));
        li.classList.add('selected');
        headingName.textContent = li.textContent.trim();
        select.value = selectedValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        this.debouncedOnSubmit(event);
      });
    });

    headingName.addEventListener('click', () => {
      const parent = headingName.closest('.facet-filters__field');
      if (parent) {
        parent.classList.toggle('active');
      }
    });
  }

  /* END:Sort By Custom*/

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      setTimeout(() => {
        FacetFiltersForm.renderPage(searchParams, event, false);
      }, 1000);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    initInfiniteScroll();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.rangeSliderPrice();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
    });
    this.setMinAndMaxValues();
    const numberS = this.querySelectorAll('input[type=number]');
    let value1 = numberS[0]?.value;
    let value2 = numberS[1]?.value;

    this.updateDisplay(value1, value2);
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  rangeSliderPrice() {
    var rangeS = this.querySelectorAll('input[type=range]'),
      numberS = this.querySelectorAll('input[type=number]');

    rangeS.forEach((element, index) => {
      element.oninput = () => {
        let slide1 = parseFloat(rangeS[0].value);
        let slide2 = parseFloat(rangeS[1].value);
        const minGap = 1;

        if (index === 0 && slide1 >= slide2 - minGap) {
          slide1 = slide2 - minGap;
          rangeS[0].value = slide1;
        }

        if (index === 1 && slide2 <= slide1 + minGap) {
          slide2 = slide1 + minGap;
          rangeS[1].value = slide2;
        }

        numberS[0].value = slide1;
        numberS[1].value = slide2;
        this.updateDisplay(slide1, slide2);
        this.updatePrice(slide1, slide2);
      };
    });
  }

  updateDisplay(value1, value2) {
    const range = this.querySelector('input[type=range]');
    const priceSlideRangeContainer = this.querySelector('.facets__price--slide');
    const max = parseInt(range.max);
    const width = 317;

    const leftSpace = (parseInt(value1) / max) * width + 'px';
    const rightSpace = width - (parseInt(value2) / max) * width + 'px';

    const range_slider_max = document.querySelector('.filter__price_max');
    const hintMax = document.querySelector('.label__filter-max');
    const hintMaxMb = document.querySelector('.mobile-facets-price .label__filter-max');
    const range_slider_min = document.querySelector('.filter__price_min');
    const hintMin = document.querySelector('.label__filter-min');
    const hintMinMb = document.querySelector('.mobile-facets-price .label__filter-min');

    const thumbnWidth = 8;
    const offset = width / (parseInt(range_slider_max.max) - parseInt(range_slider_max.min));

    this.updateHintPosition(range_slider_max, offset, hintMax, thumbnWidth, true);
    this.updateHintPosition(range_slider_min, offset, hintMin, thumbnWidth);
    this.updateHintPosition(range_slider_max, offset, hintMaxMb, thumbnWidth);
    this.updateHintPosition(range_slider_min, offset, hintMinMb, thumbnWidth);

    if (priceSlideRangeContainer) {
      priceSlideRangeContainer.style.setProperty('--left-space', leftSpace);
      priceSlideRangeContainer.style.setProperty('--right-space', rightSpace);
    }
  }

  updateHintPosition(slider, offset, hint, thumbnWidth, adjustLeft = false) {
    if (!slider || !hint) return;

    const sliderMin = parseInt(slider.min);
    const sliderMax = parseInt(slider.max);
    const value = slider.valueAsNumber;

    hint.innerHTML = value + '€';
    hint.style.top = slider.offsetHeight - 23 + 'px';

    let left =
      (value - sliderMin) * offset - hint.offsetWidth / 2 - (value / (sliderMax - sliderMin) - 0.5) * thumbnWidth;

    if (adjustLeft) left -= 14;

    hint.style.left = left + 'px';
  }

  updatePrice(min, max) {
    const $currentMin = document.querySelector('.money--current-min');
    const $currentMax = document.querySelector('.money--current-max');
    const $labelMin = document.querySelector('.label__filter-min .text');
    const $labelMax = document.querySelector('.label__filter-max .text');

    if ($currentMin) $currentMin.innerHTML = min;
    if ($currentMax) $currentMax.innerHTML = max;
    if ($labelMin) $labelMin.innerHTML = min;
    if ($labelMax) $labelMax.innerHTML = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
